/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_GENERATED_SCHEDULES = '[Schedule] Get Generated Schedules',
  GET_GENERATED_SCHEDULES_SUCCESS = '[Schedule] Get Generated Schedules Success',
  GET_GENERATED_SCHEDULES_FAILED = '[Schedule] Get Generated Schedules Failed',

  GENERATE_SCHEDULE = '[Schedule] Generate Schedule',
  GENERATE_SCHEDULE_SUCCESS = '[Schedule] Generate Schedule Success',
  GENERATE_SCHEDULE_FAILED = '[Schedule] Generate Schedule Failed',
  RESET_GENERATED_SCHEDULE = '[Schedule] Reset Generated Schedule',

  GET_GENERATED_SCHEDULE_PROGRESS = '[Schedule] Get Generated Schedule Progress',
  GET_GENERATED_SCHEDULE_PROGRESS_SUCCESS = '[Schedule] Get Generated Schedule Progress Success',
  GET_GENERATED_SCHEDULE_PROGRESS_FAILED = '[Schedule] Get Generated Schedule Progress Failed',

  GET_GENERATED_SCHEDULE_DETAILS = '[Schedule] Get Generated Schedule Details',
  GET_GENERATED_SCHEDULE_DETAILS_SUCCESS = '[Schedule] Get Generated Schedule Details Success',
  GET_GENERATED_SCHEDULE_DETAILS_FAILED = '[Schedule] Get Generated Schedule Details Failed',
  RESET_GENERATED_SCHEDULE_DETAILS = '[Schedule] Reset Generated Schedule Details',

  GET_SCHEDULE_DETAILS_OPTIONS = '[Schedule] Get Schedule Details Options',
  GET_SCHEDULE_DETAILS_OPTIONS_SUCCESS = '[Schedule] Get Schedule Details Options Success',
  GET_SCHEDULE_DETAILS_OPTIONS_FAILED = '[Schedule] Get Schedule Details Options Failed',

  CONFIRM_SCHEDULE = '[Schedule] Confirm Schedule',

  GENERATE_STUDENT_SCHEDULE = '[Schedule] Generate Student Schedule',
  GENERATE_STUDENT_SCHEDULE_SUCCESS = '[Schedule] Generate Student Schedule Success',
  GENERATE_STUDENT_SCHEDULE_FAILED = '[Schedule] Generate Student Schedule Failed',

  FINALIZE_SCHEDULE = '[Schedule] Finalize Schedule',
  FINALIZE_SCHEDULE_SUCCESS = '[Schedule] Finalize Schedule Success',
  FINALIZE_SCHEDULE_FAILED = '[Schedule] Finalize Schedule Failed',

  GET_SCHEDULES_UNMATCHED = '[Schedule] Get Schedules Unmatched',
  GET_SCHEDULES_UNMATCHED_SUCCESS = '[Schedule] Get Schedules Unmatched Success',
  GET_SCHEDULES_UNMATCHED_FAILED = '[Schedule] Get Schedules Unmatched Failed',

  CREATE_SCHEDULE_DETAILS = '[Schedule] Create Schedule Details',
  CREATE_SCHEDULE_DETAILS_SUCCESS = '[Schedule] Create Schedule Details Success',
  CREATE_SCHEDULE_DETAILS_FAILED = '[Schedule] Create Schedule Details Failed',

  UPDATE_SCHEDULE_DETAILS = '[Schedule] Update Schedule Details',
  UPDATE_SCHEDULE_DETAILS_SUCCESS = '[Schedule] Update Schedule Details Success',
  UPDATE_SCHEDULE_DETAILS_FAILED = '[Schedule] Update Schedule Details Failed',
}

export const getGeneratedSchedules = createAction(
  ActionTypes.GET_GENERATED_SCHEDULES,
  props<{ data: any }>()
);

export const getGeneratedSchedulesSuccess = createAction(
	ActionTypes.GET_GENERATED_SCHEDULES_SUCCESS,
  props<{ data: any }>()
);

export const getGeneratedSchedulesFailed = createAction(
  ActionTypes.GET_GENERATED_SCHEDULES_FAILED,
  props<{ data: any }>()
);

export const resetGeneratedSchedule = createAction(
  ActionTypes.RESET_GENERATED_SCHEDULE
);

export const generateSchedule = createAction(
  ActionTypes.GENERATE_SCHEDULE,
  props<{ data: any }>()
);

export const generateScheduleSuccess = createAction(
	ActionTypes.GENERATE_SCHEDULE_SUCCESS,
  props<{ data: any }>()
);

export const generateScheduleFailed = createAction(
  ActionTypes.GENERATE_SCHEDULE_FAILED,
  props<{ data: any }>()
);

export const getGeneratedScheduleProgress = createAction(
  ActionTypes.GET_GENERATED_SCHEDULE_PROGRESS,
  props<{ data: any }>()
);

export const getGeneratedScheduleProgressSuccess = createAction(
	ActionTypes.GET_GENERATED_SCHEDULE_PROGRESS_SUCCESS,
  props<{ data: any}>()
);

export const getGeneratedScheduleProgressFailed = createAction(
  ActionTypes.GET_GENERATED_SCHEDULE_PROGRESS_FAILED,
  props<{ data: any }>()
);

export const getGeneratedScheduleDetails = createAction(
  ActionTypes.GET_GENERATED_SCHEDULE_DETAILS,
  props<{ data: any, student: any }>()
);

export const getGeneratedScheduleDetailsSuccess = createAction(
	ActionTypes.GET_GENERATED_SCHEDULE_DETAILS_SUCCESS,
  props<{ data: any, student: any}>()
);

export const getGeneratedScheduleDetailsFailed = createAction(
  ActionTypes.GET_GENERATED_SCHEDULE_DETAILS_FAILED,
  props<{ data: any }>()
);

export const resetGeneratedScheduleDetails = createAction(
  ActionTypes.RESET_GENERATED_SCHEDULE_DETAILS
);

export const confirmSchedule = createAction(
  ActionTypes.CONFIRM_SCHEDULE,
  props<{ data: any }>()
);

export const generateStudentSchedule = createAction(
  ActionTypes.GENERATE_STUDENT_SCHEDULE,
  props<{ data: any, student: any, schedule: any }>()
);

export const generateStudentScheduleSuccess = createAction(
	ActionTypes.GENERATE_STUDENT_SCHEDULE_SUCCESS,
  props<{ data: any, student: any, schedule: any, preview: any}>()
);

export const generateStudentScheduleFailed = createAction(
  ActionTypes.GENERATE_STUDENT_SCHEDULE_FAILED,
  props<{ data: any }>()
);

export const finalizeSchedule = createAction(
  ActionTypes.FINALIZE_SCHEDULE,
  props<{ data: any, term_id: any }>()
);

export const finalizeScheduleSuccess = createAction(
	ActionTypes.FINALIZE_SCHEDULE_SUCCESS,
  props<{ data: any, term_id: any}>()
);

export const finalizeScheduleFailed = createAction(
  ActionTypes.FINALIZE_SCHEDULE_FAILED,
  props<{ data: any }>()
);

export const getScheduleDetailsOptions = createAction(
  ActionTypes.GET_SCHEDULE_DETAILS_OPTIONS,
  props<{ data: any }>()
);

export const getScheduleDetailsOptionsSuccess = createAction(
	ActionTypes.GET_SCHEDULE_DETAILS_OPTIONS_SUCCESS,
  props<{ data: any, schedule_id: any }>()
);

export const getScheduleDetailsOptionsFailed = createAction(
  ActionTypes.GET_SCHEDULE_DETAILS_OPTIONS_FAILED,
  props<{ data: any }>()
);

export const getSchedulesUnmatched = createAction(
  ActionTypes.GET_SCHEDULES_UNMATCHED,
  props<{ data: any }>()
);

export const getSchedulesUnmatchedSuccess = createAction(
	ActionTypes.GET_SCHEDULES_UNMATCHED_SUCCESS,
  props<{ data: any }>()
);

export const getSchedulesUnmatchedFailed = createAction(
  ActionTypes.GET_SCHEDULES_UNMATCHED_FAILED,
  props<{ data: any }>()
);

export const createScheduleDetails = createAction(
  ActionTypes.CREATE_SCHEDULE_DETAILS,
  props<{ data: any }>()
);

export const createScheduleDetailsSuccess = createAction(
	ActionTypes.CREATE_SCHEDULE_DETAILS_SUCCESS,
  props<{ data: any, schedule_id }>()
);

export const createScheduleDetailsFailed = createAction(
  ActionTypes.CREATE_SCHEDULE_DETAILS_FAILED,
  props<{ data: any }>()
);

export const updateScheduleDetails = createAction(
  ActionTypes.UPDATE_SCHEDULE_DETAILS,
  props<{ data: any }>()
);

export const updateScheduleDetailsSuccess = createAction(
	ActionTypes.UPDATE_SCHEDULE_DETAILS_SUCCESS,
  props<{ data: any, schedule_id }>()
);

export const updateScheduleDetailsFailed = createAction(
  ActionTypes.UPDATE_SCHEDULE_DETAILS_FAILED,
  props<{ data: any }>()
);